//require('./bootstrap');
import '../css/app.css';
require('./navigation.js')
require('./forms.js')
require('./components/modal.js')
require('./components/popover.js')
require('./components/iframe.js')